import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IGetRestaurantAvailableDaysResponseApi } from "@interfaces/IGetRestaurantAvailableDaysResponseApi.ts"
import { IGetRestaurantAvailableDaysResponseCli } from "@interfaces/IGetRestaurantAvailableDaysResponseCli.ts"

export const GetRestaurantAvailableDaysAdapter = ({
	data,
}: IApiResponse<IGetRestaurantAvailableDaysResponseApi>): IGetRestaurantAvailableDaysResponseCli => {
	return {
		placeId: data.place_id,
		availableDays: data.available_days,
	}
}
